import React from "react";
import ReactDOM from "react-dom";
import { BaseProvider, LightTheme } from "baseui";
import { Provider as StyletronProvider } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";

import "./index.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assests/font-awesome/css/all.css";

function onKonamiCode(fn) {
	var codes = (function(){
			var c = [38,38,40,40,37,39,37,39,66,65];
			onKonamiCode.requireEnterKey && c.push(13);
			return c;
		})(),
		expecting = function(){
			expecting.codes = expecting.codes || Array.apply({}, codes);
			expecting.reset = function() { expecting.codes = null; };
			return expecting.codes;
		},
		handler = function(e) {
			if (expecting()[0] === (e||window.event).keyCode) {
				expecting().shift();
				if (!expecting().length) {
					expecting.reset();
					fn();
				}
			} else { expecting.reset(); }
		};
	window.addEventListener ?
		window.addEventListener('keydown', handler, false)
		: document.attachEvent('onkeydown', handler);
}
onKonamiCode.requireEnterKey = false;
onKonamiCode(function(){
	alert("you found my secret code!  prepare for Cube Ninja Extreme!");
	window.location="https://cubecrusherninja.netlify.app/";
});

const engine = new Styletron();

ReactDOM.render(
  <StyletronProvider value={engine}>
    <BaseProvider theme={LightTheme}>
      <App />
    </BaseProvider>
  </StyletronProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
